import request from '@/services/axios'

// 获取消息列表
export const getNotificationList = (data: any) => {
  return request.post('/api/message/page', data)
}

// 获取未读消息数量
export const getUnreadCount = (data: any) => {
  return request.post('/api/notification/unreadCount', data)
}

// 标记单条消息已读
export const markNotificationRead = (data: any) => {
  return request.post('/api/message/read', data)
}

// 标记全部已读
export const markAllNotificationRead = (data: any) => {
  return request.post('/api/message/read-all', data)
}

// 删除单条消息
export const deleteNotification = (data: any) => {
  return request.post('/api/message/delete', data)
}